import {Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';

export interface HttpErrorTrace {
  status: number;
  statusText: string;
  url: string;
  message: string;
  error: unknown;
  timestamp: number;
}

@Injectable({
  providedIn: 'root',
})
export class HttpErrorTraceService {
  private latestTrace: HttpErrorTrace | null = null;

  capture(error: HttpErrorResponse): void {
    this.latestTrace = {
      status: error.status,
      statusText: error.statusText ?? '',
      url: error.url ?? '',
      message: error.message ?? '',
      error: error.error,
      timestamp: Date.now(),
    };
  }

  getRecent(maxAgeMs: number = 5000): HttpErrorTrace | null {
    if (!this.latestTrace) {
      return null;
    }
    if (Date.now() - this.latestTrace.timestamp > maxAgeMs) {
      return null;
    }
    return this.latestTrace;
  }
}
